import { useEffect } from 'react'
import { useAuthStore } from '@stores/auth.context/auth.context'

const Chatwoot = () => {
  const { user, selectedHub } = useAuthStore()

  useEffect(() => {
    if (user && selectedHub) {
      const hasHubUuid = window.localStorage.getItem('hub_uuid')
      const nameHub = user?.hubs.find((hub) => hub.uuid === hasHubUuid)?.trading_name

      const BASE_URL = 'https://crm.hubii.co'
      const loadChatwoot = () => {
        window.chatwootSDK.run({
          websiteToken: import.meta.env.VITE_CHATWOOT_WEBSITE_TOKEN,
          baseUrl: BASE_URL,
          identifier: selectedHub.uuid,
        })
      }

      const chatWootScript = document.createElement('script')
      chatWootScript.src = `${BASE_URL}/packs/js/sdk.js`
      chatWootScript.async = true
      chatWootScript.onload = loadChatwoot
      document.head.appendChild(chatWootScript)

      const configureChatwootUser = () => {
        if (window.$chatwoot && user && selectedHub) {
          window.$chatwoot.setCustomAttributes({
            hub: nameHub,
          })
          window.$chatwoot.setUser(user.email, {
            name: user.name,
            email: user.email,
            company_name: nameHub,
          })
        } else {
          console.error('chatwootSDK not found')
        }
      }

      const onChatwootLoaded = () => {
        configureChatwootUser()
      }

      window.addEventListener('chatwoot:ready', onChatwootLoaded)

      return () => {
        if (window.$chatwoot) {
          window.$chatwoot.reset()
        }
        window.removeEventListener('chatwoot:ready', onChatwootLoaded)
        document.head.removeChild(chatWootScript)
      }
    }
  }, [])

  return null
}

export default Chatwoot
